import styled from "styled-components";
import assests from "../../ui/assests";

export const TestimonialsCompWrapper = styled.div`
  .testimonialInner {
    min-height: 550px;
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    @media (max-width: 1199px) {
      padding: 45px 20px;
      min-height: 450px;
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      min-height: auto;
      border-radius: 10px;
    }
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 79%;
      left: 0px;
      bottom: 0;
      z-index: 1;
      background: linear-gradient(
        358.33deg,
        #000000 1.07%,
        rgba(0, 0, 0, 0) 98.25%
      );
    }
    .testimonialBg_overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .testimonial_data_Wrap {
      position: relative;
      z-index: 2;
      .slick-list {
        margin: -15px;
        .slideCard_cols {
          display: flex !important;
          align-items: stretch;
          flex-wrap: wrap;
          margin: -6.5px;
          padding: 15px;
          * {
            color: rgba(255, 255, 255, 1);
          }
          .cmn_col {
            height: auto;
          }
          .left_div {
            padding: 6.5px;
            max-width: 370px;
            width: 100%;
            align-items: center;
            @media (max-width: 1199px) {
              max-width: 350px;
            }
            @media (max-width: 899px) {
              max-width: 100%;
            }
            i {
              max-width: 119px;
              width: 100%;
              margin-right: 45px;
              @media (max-width: 1199px) {
                margin-right: 15px;
              }
              @media (max-width: 899px) {
                max-width: 90px;
              }
              @media (max-width: 599px) {
                max-width: 60px;
              }
            }
            p {
              font-weight: 700;
              font-size: 36px;
              max-width: calc(100% - 164px);
              @media (max-width: 1199px) {
                font-size: 30px;
                max-width: calc(100% - 134px);
              }
              @media (max-width: 899px) {
                max-width: calc(100% - 105px);
                font-size: 26px;
              }
              @media (max-width: 599px) {
                max-width: calc(100% - 75px);
                font-size: 22px;
              }
            }
          }
          .right_div {
            max-width: calc(100% - 370px);
            width: 100%;
            padding: 6.5px;
            @media (max-width: 1199px) {
              max-width: calc(100% - 350px);
            }
            @media (max-width: 899px) {
              max-width: 100%;
            }
            .descriptionText {
              position: relative;
              padding: 28px 40px;
              @media (max-width: 1199px) {
                padding: 18px 35px;
              }
              &::before {
                content: "";
                background: url(${assests.testimonialOverlay}) no-repeat;
                position: absolute;
                width: 32px;
                height: 22px;
                top: 0;
                left: 0;
              }
              &::after {
                content: "";
                background: url(${assests.testimonialOverlay}) no-repeat;
                position: absolute;
                width: 32px;
                height: 22px;
                bottom: 0;
                right: 0;
              }
              p {
                font-size: 20px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                @media (max-width: 899px) {
                  font-size: 16px;
                }
                @media (max-width: 599px) {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
